import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/Images/planeta_animacion.gif'
import _imports_1 from '../../assets/Images/img-home.png'
import _imports_2 from '../../assets/Images/logo02.png'
import _imports_3 from '../../assets/Images/arrow-down.svg'
import _imports_4 from '../../assets/Images/Videos/Video-Welcome-Ingles.mp4'
import _imports_5 from '../../assets/Images/img-welcome.png'
import _imports_6 from '../../assets/Images/Videos/Video-Welcome-Espanol.mp4'
import _imports_7 from '../../assets/Images/img-02.png'
import _imports_8 from '../../assets/Images/Videos/Video-Overview.mp4'
import _imports_9 from '../../assets/Images/img-overview.png'
import _imports_10 from '../../assets/Images/img-04.png'
import _imports_11 from '../../assets/Images/Videos/Marketing.mp4'
import _imports_12 from '../../assets/Images/img-marketing.png'


const _hoisted_1 = { class: "home-realtors" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"modal fade\" id=\"modalMaintenance\" tabindex=\"-1\" aria-labelledby=\"exampleModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-xl\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"btn-close custom-close-button\" data-bs-dismiss=\"modal\" aria-label=\"Close\"><i class=\"fas fa-times\"></i></button></div><div class=\"modal-body\"></div></div></div></div>", 1)
const _hoisted_3 = { class: "container-fixed" }
const _hoisted_4 = { class: "hidden-mobile" }
const _hoisted_5 = { class: "home-realtors__navbar" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"home-realtors__real-state tw-bg-[#fff] tw-flex tw-pb-10 tw-justify-center tw-pt-10\"><div class=\"\"><div class=\"home-realtors__real-state__img01\"><img src=\"" + _imports_0 + "\" alt=\"\"></div></div><div class=\"d-flex tw-justify-center\"><div class=\"home-realtors__real-state__slider\"><div class=\"home-realtors__real-state__img01\"><span class=\"tw-font-black tw-text-white tw-leading-[2px]\" style=\"text-shadow:5px 5px 15px #4b4949;\">THE WORLD</span> <br><span class=\"tw-font-black tw-text-[#00a0da]\">AT YOUR FEET</span></div><div class=\"tw-flex tw-justify-center\"><hr style=\"border:1px solid #606060;width:200px !important;\"></div><div class=\"tw-flex tw-items-center tw-justify-center tw-pt-3 tw-pb-3\"><span class=\"tw-text-[#606060] tw-text-[18px]\">Reaching the whole world</span></div><div class=\"home-realtors__real-state__img02 tw-flex tw-justify-center\"><img src=\"" + _imports_1 + "\" alt=\"\"></div></div></div></div>", 1)
const _hoisted_7 = { class: "visible-mobile" }
const _hoisted_8 = { class: "navbar navbar-expand-lg navbar-light bg-light" }
const _hoisted_9 = { class: "container-fluid" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "/"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-w-[100px]",
    src: _imports_2,
    alt: ""
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarNavDropdown",
  "aria-controls": "navbarNavDropdown",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_12 = {
  class: "collapse navbar-collapse",
  id: "navbarNavDropdown"
}
const _hoisted_13 = { class: "navbar-nav tw-text-left tw-mt-5" }
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = { class: "nav-item tw-mt-3" }
const _hoisted_16 = { class: "nav-item d-flex justify-content-left tw-mt-3" }
const _hoisted_17 = { class: "dropdown tw-block tw-relative" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("a", {
  class: "tw-text-[#606060] tw-flex tw-justify-between tw-w-[120px] tw-items-center",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" PRODUCTS"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1)
const _hoisted_19 = {
  class: "dropdown-menu",
  style: {"width":"150px !important","font-size":"12px"}
}
const _hoisted_20 = { class: "nav-item tw-mt-3" }
const _hoisted_21 = { class: "nav-item tw-mt-1" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle tw-text-[#606060] tw-font-bold tw-flex tw-gap-[19px]",
  href: "#",
  id: "navbarDropdownMenuLink",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" SIGN UP"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1)
const _hoisted_23 = {
  class: "dropdown-menu",
  "aria-labelledby": "navbarDropdownMenuLink"
}
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"realtors-tools tw-bg-[#fff] tw-pt-10 tw-drop-shadow-2xl\"><div class=\"container\"><div class=\"hidden-mobile\"><div class=\"tw-flex tw-justify-around tw-gap-[50px]\"><div><span class=\"tw-text-[40px] tw-text-[#00a0da]\">Welcome</span><video class=\"tw-mt-[20px]\" src=\"" + _imports_4 + "\" width=\"600\" height=\"250\" poster=\"" + _imports_5 + "\" controls></video></div><div><span class=\"tw-text-[40px] tw-text-[#00a0da]\">Bienvenido</span><video class=\"tw-mt-[20px]\" src=\"" + _imports_6 + "\" width=\"600\" height=\"250\" poster=\"" + _imports_5 + "\" controls></video></div></div></div><div class=\"visible-mobile\"><div class=\"d-flex tw-justify-center\"><div class=\"content-videos\"><div class=\"welcome\"><span class=\"tw-text-[40px] tw-text-[#00a0da]\">Welcome</span><video class=\"tw-mt-[20px]\" src=\"" + _imports_4 + "\" width=\"350\" height=\"250\" poster=\"" + _imports_5 + "\" controls></video></div><div class=\"bienvenido\"><span class=\"tw-text-[40px] tw-text-[#00a0da]\">Bienvenido</span><video class=\"tw-mt-[20px]\" src=\"" + _imports_6 + "\" width=\"350\" height=\"250\" poster=\"" + _imports_5 + "\" controls></video></div></div></div></div><div class=\"realtors-tools__section2 tw-mt-[80px]\"><div class=\"realtors-tools__section2__tittle\"><span>REALTOR TOOLS</span></div><div class=\"visible-mobile\"><div class=\"realtors-tools__section2__text tw-text-justify tw-pl-3 tw-pr-3\"><span class=\"\">Realtor Tolls is a revolutionary platform that brings together all the stakeholders involved in the real state business.</span></div></div><div class=\"hidden-mobile\"><div class=\"realtors-tools__section2__text\"><span>Realtor Tolls is a revolutionary platform that brings together all the stakeholders <br> involved in the real state business.</span></div></div><div class=\"visible-mobile\"><div class=\"image d-flex tw-justify-center tw-mt-[-20px]\"><img src=\"" + _imports_7 + "\" alt=\"\"></div></div><div class=\"tw-justify-center tw-flex tw-items-center tw-gap-[100px]\"><div class=\"hidden-mobile\"><div class=\"expert\"><span>Realtor Expert</span><p>As Realtor, you now have access to a <br> powerful and interactive tool that turns <br> you into an expert in real estate, both in <br> the residential and investment fields.</p></div></div><div class=\"visible-mobile\"><div class=\"expert tw-mt-[30px]\"><span class=\"d-flex tw-justify-center\">Realtor Expert</span><p>As Realtor, you now have access to a powerful and interactive tool that turns you into an expert in real estate, both in the residential and investment fields.</p></div></div><div class=\"hidden-mobile\"><div class=\"image\"><img src=\"" + _imports_7 + "\" alt=\"\"></div></div></div></div></div></div><div class=\"overview-system\"><div class=\"container\"><div class=\"overview-system__section3\"><div class=\"overview-system__section3__tittle\"><span>Overview System</span></div><div class=\"hidden-mobile\"><div class=\"overview-system__section3__text\"><p>This video provides an overview of Realtor Tools, a system specifically designed <br> for the real estate industry. Explore the various scenarios and stakeholders <br> within the real estate sector, enhancing efficiency and productivity.</p></div></div><div class=\"visible-mobile\"><div class=\"overview-system__section3__text\"><p>This video provides an overview of Realtor Tools, a system specifically designed for the real estate industry. Explore the various scenarios and stakeholders within the real estate sector, enhancing efficiency and productivity.</p></div></div><div class=\"hidden-mobile\"><div class=\"overview-system__section3__video tw-flex tw-justify-center\"><video src=\"" + _imports_8 + "\" controls poster=\"" + _imports_9 + "\" width=\"600\" height=\"250\"></video></div></div><div class=\"visible-mobile\"><div class=\"overview-system__section3__video tw-flex tw-justify-center\"><video src=\"" + _imports_8 + "\" controls poster=\"" + _imports_9 + "\" width=\"350\" height=\"250\"></video></div></div></div></div></div><div class=\"realtor-expert tw-bg-[#fff] tw-pb-14\"><div class=\"container\"><div class=\"realtor-expert__section4\"><div class=\"realtor-expert__section4__tittle\"><span>Realtor EXPERT</span></div></div><div class=\"realtor-expert__section4__imagen tw-flex tw-justify-center\"><img class=\"img-realtor-expert\" src=\"" + _imports_10 + "\" alt=\"\"></div></div></div><div class=\"tw-bg-[#f2f2f2]\"><div class=\"world-your-feet tw-pt-[68px]\"><span class=\"tw-text-[40px] tw-text-[#00a0da]\"> THE WORLD AT YOUR FEET </span></div><div class=\"hidden-mobile\"><div class=\"tw-flex tw-justify-center tw-pt-[20px] tw-pb-[65px]\"><video src=\"" + _imports_11 + "\" width=\"600\" height=\"250\" controls poster=\"" + _imports_12 + "\"></video></div></div><div class=\"visible-mobile\"><div class=\"tw-flex tw-justify-center tw-pt-[20px] tw-pb-[65px]\"><video src=\"" + _imports_11 + "\" width=\"350\" height=\"250\" controls poster=\"" + _imports_12 + "\"></video></div></div></div>", 4)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_routerLink = _resolveComponent("routerLink")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Header),
            _hoisted_6
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("nav", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("ul", _hoisted_13, [
                  _createElementVNode("li", _hoisted_14, [
                    _createVNode(_component_routerLink, {
                      class: "tw-text-[#606060]",
                      to: "/"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("HOME")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_15, [
                    _createVNode(_component_routerLink, {
                      class: "tw-text-[#606060]",
                      to: "/target"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("TARGET")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_16, [
                    _createElementVNode("a", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("ul", _hoisted_19, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            href: "#",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal('modalProducts', '1')))
                          }, "RESIDENTIAL")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            href: "#",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal('modalProducts', '2')))
                          }, "INVESTMENT")
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_20, [
                    _createVNode(_component_routerLink, {
                      class: "tw-text-[#606060]",
                      to: "/loginusers"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("LOG IN ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("ul", _hoisted_23, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listRoles, (role, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                          (role.name != 'ADMIN' && role.name != 'REALTOR')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "dropdown-item",
                                style: {"font-size":"12px"},
                                id: "option",
                                href: '/register?type=' + role.idRole
                              }, _toDisplayString(role.name), 9, _hoisted_24))
                            : _createCommentVNode("", true),
                          (role.name == 'REALTOR')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "dropdown-item",
                                style: {"font-size":"12px"},
                                id: "option",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openModal('modalMaintenance')))
                              }, _toDisplayString(role.name), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_25,
    _createVNode(_component_Footer)
  ], 64))
}